import { createAction } from '@reduxjs/toolkit';

const setUser = createAction('account/user');
const setUserPreferences = createAction('account/user/setPreferences');

export { setUser, setUserPreferences };
